import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { ModelAttributeConfig } from '@zipari/shared-ds-util-configuration';
import { Observable, Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  downloadClaimDetailsInit,
  downloadEOBInit,
} from '../../store/side-panel.actions';
import { selectActiveClaim } from '../../store/side-panel.selectors';
import { ActiveClaim } from '../../side-panel.constants';

@Component({
  selector: 'side-panel-downloads',
  templateUrl: './side-panel-downloads.component.html',
  styleUrls: ['./side-panel-downloads.component.scss'],
})
export class SidePanelDownloadsComponent implements OnInit, OnDestroy {
  @Input() downloadsLabel = 'Downloads';
  @Input() attributeList: ModelAttributeConfig[] = [];
  @Input() attributeListContext: any;
  @Input() useCustom: boolean;
  @Input() activeClaim: ActiveClaim;

  claim$: Observable<any> = this.store.pipe(select(selectActiveClaim));
  private subscription: Subscription = new Subscription();

  documentIds: { eob_document_id: string; claim_details_document_id: string } =
    {
      eob_document_id: null,
      claim_details_document_id: null,
    };
  noLinks: boolean;

  constructor(private store: Store) {}

  hasAtLeastOneValidLink() {
    this.noLinks =
      !this.documentIds.eob_document_id &&
      !this.documentIds.claim_details_document_id;
  }

  ngOnInit() {
    if (this.activeClaim && Object.keys(this.activeClaim).length > 0) {
      this.setDocumentIds(this.activeClaim);
    } else {
      this.subscription.add(
        this.claim$.pipe(filter((claim) => !!claim)).subscribe((claim) => {
          this.setDocumentIds(claim);
        }),
      );
    }
  }

  private setDocumentIds(claim: any) {
    this.documentIds.eob_document_id = claim.eob_document_id
      ? claim.eob_document_id
      : null;
    this.documentIds.claim_details_document_id = claim.id ? claim.id : null;
    this.hasAtLeastOneValidLink();
  }

  downloadPDF(document: string) {
    const documentId = this.documentIds[document];

    switch (document) {
      case 'eob_document_id':
        this.store.dispatch(
          downloadEOBInit({ payload: { eobDocumentId: documentId } }),
        );
        break;
      case 'claim_details_document_id':
        this.store.dispatch(
          downloadClaimDetailsInit({
            payload: { claimDetailsDocumentId: documentId },
          }),
        );
        break;
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
